import React from 'react'
import {Box, Button} from 'theme-ui';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import {useResponsiveValue} from "@theme-ui/match-media";
import { connect } from 'react-redux';
import { Card } from '~/Companies';
import { Icon } from 'assets/Icon';

const mapStateToProps = (state) => {
    return { companies: state.companies }
}

const PrevArrow = (props) => {
    const { onClick } = props;
    return (
        <Button
        variant='companySlick'
        onClick={onClick}
        sx={{ left: 0 }}
      >
        <Icon icon="chevron-left" size="10px" color="white" strokeWidth="2px" />
      </Button>
    );
  };
  
  // Custom Next Arrow
  const NextArrow = (props) => {
    const { onClick } = props;
    return (
      <Button
        variant='companySlick'
        onClick={onClick}
        sx={{ left: '40px' }}
      >
        <Icon icon="chevron-right" size="10px" color="white" strokeWidth="2px" />
      </Button>
    );
  };
  

const CompaniesCarousel = ({ companies }) => {
    const isMobile = useResponsiveValue([true, false]);
    const data = companies.companies?.results || [];

    let slidesToShow;
    if (isMobile) {
        slidesToShow = 1;
    } else {
        slidesToShow = data.length > 3 ? 3 : data.length;
    }

    const settings = {
        infinite: true,
        speed: 500,
        slidesToShow: slidesToShow,
        slidesToScroll: 1,
        arrows: true,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />
      };

    return (
            <Box>
                {data.length > 0 ? (
                    <Box sx={{
                        py: 2,
                        alignItems: 'center',
                        position: 'relative',
                        marginBottom: '40px'
                    }}
                    >
                        <Slider {...settings}>
                            {data.map((item, key) => (
                                <Box sx={{maxWidth: '432px'}} key={key}>
                                    <Card company={item} showDeals={false} />
                                </Box>
                            ))}
                        </Slider>
                    </Box>
                ) : null}
            </Box>
    );
};

export default connect(mapStateToProps, null)(CompaniesCarousel);
